import { MONTHS } from '../../../constants/months';
import { NBSP } from '../../../constants/symbols';

export interface IGetHeaderTextParams {
  date?: string;
}

export function getHeaderText({ date }: IGetHeaderTextParams) {
  const currentDate = date ? new Date(date) : new Date();
  const day = currentDate.getDate();
  const month = MONTHS[currentDate.getMonth()];
  const year = currentDate.getFullYear();

  return `Оценка квартиры на${NBSP}${day}${NBSP}${month}${NBSP}${year}`;
}
